module.exports = __webpack_public_path__ + "img/iminencia.5eee6cab.jpg";